import { useHistory, useLocation } from 'react-router';

export const useSetFilter = () => {
  const { replace } = useHistory();
  const { pathname } = useLocation();

  return (value: string) => replace(`${pathname}?filter=${value}`);
};
